var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-sm-8 col-lg-8 m-auto" }, [
        _c("div", { staticClass: "main_container" }, [
          _c("div", { staticClass: "no_results_container" }, [
            _c("div", { staticClass: "no_results_title" }, [
              _c("div", { staticClass: "no_results_title_circle" }),
              _c("div", { staticClass: "opt-out-wrapper" }, [
                _c("h1", [
                  _vm._v(
                    _vm._s(
                      _vm.$root.trans("st_public.removing your listing title", {
                        domain: _vm.domain
                      })
                    )
                  )
                ])
              ])
            ]),
            _c(
              "div",
              {
                staticClass: "no_results_suggestions",
                staticStyle: { "background-color": "#fff" }
              },
              [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$root.trans(
                        "st_public.removing your listing details",
                        { domain: _vm.domain }
                      )
                    )
                  }
                })
              ]
            ),
            _c("div", { staticClass: "search_again_container" }, [
              _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errorMessage,
                        expression: "errorMessage"
                      }
                    ],
                    staticClass: "mt-1 rounded pt-1",
                    staticStyle: {
                      "background-color": "#f00",
                      color: "#fff",
                      "font-weight": "bold",
                      "font-size": "14px"
                    },
                    attrs: { id: "error_message" }
                  },
                  [
                    _c("span", { staticClass: "fa fa-exclamation-triangle" }),
                    _vm._v(" " + _vm._s(_vm.errorMessage))
                  ]
                ),
                _c(
                  "form",
                  {
                    staticClass: "advanced_filters_controller",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.removeFromListing($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "advanced_filters_container monolithic_advanced_filters_container"
                      },
                      [
                        _c("div", { staticClass: "advanced_filters" }, [
                          _c("div", { staticClass: "advanced_filters_form" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "float_input_set float_base_8_12_12"
                              },
                              [
                                !_vm.cannotFindProfile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "label_input_set unstyled"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "unstyled " },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")("st_public.url")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "label",
                                          { staticClass: "details " },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$root.trans(
                                                  "st_public.url label details",
                                                  { domain: _vm.domain }
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "unstyled valid ",
                                          attrs: {
                                            id: "url",
                                            name: "url",
                                            placeholder: _vm._f("trans")(
                                              "st_public.url_example_placeholder"
                                            ),
                                            type: "text",
                                            autocomplete: "on"
                                          }
                                        }),
                                        _c(
                                          "a",
                                          {
                                            staticStyle: {
                                              cursor: "pointer",
                                              color: "#089FE4",
                                              "font-size": "12px"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.setCannotFindProfile(
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")(
                                                  "st_public.cannot find profile?"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", {
                                  staticClass: "label_input_set unstyled"
                                }),
                                _vm.cannotFindProfile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "label_input_set unstyled"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "unstyled " },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")(
                                                  "st_public.name"
                                                )
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "unstyled valid ",
                                          attrs: {
                                            id: "name",
                                            name: "name",
                                            placeholder: _vm._f("trans")(
                                              "st_public.e_g_john_smith"
                                            ),
                                            type: "text",
                                            autocomplete: "on",
                                            value: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.cannotFindProfile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "label_input_set unstyled"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "unstyled " },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")(
                                                  "st_public.country"
                                                )
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "unstyled valid ",
                                          attrs: {
                                            id: "country",
                                            name: "country",
                                            placeholder: _vm._f("trans")(
                                              "st_public.e_g_country"
                                            ),
                                            type: "text",
                                            autocomplete: "on"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.cannotFindProfile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "label_input_set unstyled"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "unstyled " },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")(
                                                  "st_public.state"
                                                )
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "unstyled valid ",
                                          attrs: {
                                            id: "state",
                                            name: "state",
                                            placeholder: _vm._f("trans")(
                                              "st_public.e_g_state"
                                            ),
                                            type: "text",
                                            autocomplete: "on"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.cannotFindProfile
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "label_input_set unstyled"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "unstyled " },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("trans")(
                                                  "st_public.city"
                                                )
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "unstyled valid ",
                                          attrs: {
                                            id: "city",
                                            name: "city",
                                            placeholder: _vm._f("trans")(
                                              "st_public.e_g_city"
                                            ),
                                            type: "text",
                                            autocomplete: "on"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "filters_modal_form_buttons" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button green_button pull-left",
                                    attrs: { type: "submit" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("trans")(
                                          "st_public.remove this listing"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm.loading ? _c("div", { staticClass: "loading-page" }) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4063d894", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4063d894","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/optout.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4063d894","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/optout.vue
// module chunks = 35